import React from "react";
import loadable from "@loadable/component";
import PublishProductReviewLoading from "./PublishProductReviewLoading";

export const hasPublishProductReview = (product) => product.canBeReviewed;

export default loadable(() => import("./PublishProductReview"), {
  fallback: <PublishProductReviewLoading />,
});

export const addReviewAnchorId = "add-your-review";
